import thumbnailImg from 'Static/thumbnails/screenshot--states-of-matter.png';

export default {
  slug: 'states-of-matter',
  title: 'States of Matter',
  seriesNumber: '11',
  published: true,
  thumbnailImg,
  isNew: true,
  graphicFileName: 'Image_StatesofMatter.png',
  iconFileName: 'Icon_StatesofMatter.png',
  supportedLanguages: [
    'en',
    'ar',
    'bg',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fa',
    'fi',
    'fr',
    'he',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'ms',
    'nb',
    'nl',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'ice',
    'gold',
    'popcorn',
    'plastic',
    'purple_soda',
    'orange_soda',
    'oil',
    'honey',
    'bromine',
    'helium',
    'chlorine',
    'oxygen',
  ],
  featuredPrintables: ['som_observable_properties'],
  printables: [
    'som_chocolate_experiment',
    'som_sorting',
    'som_scavenger_hunt',
    'som_thermometers',
    'som_molecular_behavior',
    'som_phase_changes',
    'concept_map',
    'generating_questions',
  ],
  topics: ['three_main_states', 'structures_properties', 'phase_changes'],
  deepLinks: {},
  appLinks: {
    appStoreLink:
      'https://apps.apple.com/us/app/states-of-matter-by-tinybop/id1451999149',
  },
};
